import React from "react";

type MarkerProps = { children: React.ReactNode; lat?: number; lng?: number };

export const MapMarker: React.FC<MarkerProps> = ({ children, lat, lng }) => {
  return <>{children}</>;
};
